<div [class]="getElementClasses()" class="text-md font-bold mb-4" [innerHTML]="widget.title">
</div>
